// extracted by mini-css-extract-plugin
var _1 = "nFkIT_B_Oa";
var _2 = "E4CXHV3Sec";
export { _1 as "game", _2 as "textArea" }
